export const ADMIN_TAB_VALUES = new Set([
  "users", "groups", "sessions", "static-ad-units", "lp-templates", "features",
  "ads-express-config", "broll-express", "analytics", "creative-strategist",
  "beta-features", "bulk-import", "brands", "meme-settings",
  "story-video-styles", "slideshow-styles", "ugc-express-styles", "models",
  "credits", "cheatsheet", "slideshow-express", "storage", "gpt-image-version", "provider-routing",
  "email-section-devices", "email-express-2-prompt", "onboarding-recipe",
  "video-reference-assets", "template-studio-rules", "concept-boards",
  "creative-iterations-video-prompt", "narrative-v2",
  "persona-workflows",
]);

const STORY_VIDEO_SUB_TABS = new Set(["story-categories", "video-styles"]);

export function resolveInitialAdminTab(isMaster: boolean, search: string): string {
  const params = new URLSearchParams(search);
  let tab = params.get("tab");
  const sub = params.get("sub");

  if (tab === "meme-settings" && sub && STORY_VIDEO_SUB_TABS.has(sub)) {
    tab = "story-video-styles";
  }

  if (!isMaster) return "unauthorized";
  return tab && ADMIN_TAB_VALUES.has(tab) ? tab : "users";
}